/**
 * Die vier Reiter des Planerarbeitsplatzes (Batch 7) — dasselbe Muster wie
 * anderswo (`.reiter`/`.reiter-knopf`, siehe z. B. Aussenanlagen.tsx). Der
 * aktive Reiter kommt von außen (aus der URL, `?reiter=`) und bleibt damit
 * beim Neuladen erhalten.
 */
export function Reiter({
  gewaehlt, onWaehlen,
}: {
  gewaehlt: string;
  onWaehlen: (r: string) => void;
}) {
  const punkte: [string, string][] = [
    ['arbeiten', 'Arbeiten'],
    ['planeraufgaben', 'Planeraufgaben'],
    ['auswertung', 'Auswertung'],
    ['grundlagen', 'Grundlagen'],
  ];

  return (
    <div className="reiter" role="tablist" style={{ marginBottom: 14 }}>
      {punkte.map(([k, name]) => (
        <button
          key={k} type="button" role="tab" aria-selected={gewaehlt === k}
          className={`reiter-knopf${gewaehlt === k ? ' aktiv' : ''}`}
          onClick={() => onWaehlen(k)}
        >
          {name}
        </button>
      ))}
    </div>
  );
}
